import { render } from "./CustomAudioPlayer.vue?vue&type=template&id=b8a4bbf0&scoped=true"
import script from "./CustomAudioPlayer.vue?vue&type=script&lang=js"
export * from "./CustomAudioPlayer.vue?vue&type=script&lang=js"

import "./CustomAudioPlayer.vue?vue&type=style&index=0&id=b8a4bbf0&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a4bbf0"]])

export default __exports__